import { render, staticRenderFns } from "./SemesterSettings.vue?vue&type=template&id=48bcbf23&"
import script from "./SemesterSettings.vue?vue&type=script&lang=js&"
export * from "./SemesterSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports